const initialPaymentsList = {
  data: [],
  error: null,
  filter: { fulltext: '' },
  isFetching: false,
  order: '-dateCreated',
  page: 1,
  promoDetailModal: {
    data: {},
    detail: {},
    error: null,
    isFetching: false,
    show: false,
  },
  resultsFiltered: 0,
  resultsTotal: 0,
  rowsPerPage: 10,
};

export const initialState = {
  data: null,
  error: null,
  isFetching: false,
  list: initialPaymentsList,
};

const reducers = {};

const reducer = (state = initialState, action = {}) => {
  if (reducers[action.type]) {
    return reducers[action.type](state, action);
  }
  return state;
};

export default reducer;
